import React from "react"
import "./BSReplace.css"

export interface RowProps<T extends React.ElementType = "div"> extends React.HTMLAttributes<HTMLDivElement> {
	as?: T
	controlId?: string
}

type RowComponent = <T extends React.ElementType = "div">(
	props: RowProps<T> & { ref?: React.ComponentPropsWithRef<T>["ref"] }
) => React.ReactElement | null

export const Row: RowComponent = React.forwardRef(
	<T extends React.ElementType = "div">(
		{ className, as, ...props }: RowProps<T>,
		ref?: React.ComponentPropsWithRef<T>["ref"]
	) => {
		const Component = as ?? ("div" as React.ElementType)
		const combinedClassName = `row ${className ?? ""}`

		return <Component ref={ref} className={combinedClassName} {...props} />
	}
) as RowComponent

export default Row
